import { useSlice } from "components/hooks/useSlice";

export function useReact() {
  return useSlice("reactOnly") === "true";
}
